import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";

import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import ClientesPage from "@/pages/ClientesPage";
import ExpedientesPage from "@/pages/ExpedientesPage";
import ExpedienteDetailPage from "@/pages/ExpedienteDetailPage";
import PresupuestosPage from "@/pages/PresupuestosPage";
import PresupuestoDetailPage from "@/pages/PresupuestoDetailPage";
import FacturasPage from "@/pages/FacturasPage";
import FacturaDetailPage from "@/pages/FacturaDetailPage";
import PerfilPage from "@/pages/PerfilPage";
import IAPage from "@/pages/IAPage";

export default function App() {
  return (
    <AuthProvider>
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
            <Route path="/" element={<DashboardPage />} />
            <Route path="/clientes" element={<ClientesPage />} />
            <Route path="/expedientes" element={<ExpedientesPage />} />
            <Route path="/expedientes/:id" element={<ExpedienteDetailPage />} />
            <Route path="/presupuestos" element={<PresupuestosPage />} />
            <Route path="/presupuestos/:id" element={<PresupuestoDetailPage />} />
            <Route path="/facturas" element={<FacturasPage />} />
            <Route path="/facturas/:id" element={<FacturaDetailPage />} />
            <Route path="/ia" element={<IAPage />} />
            <Route path="/perfil" element={<PerfilPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
